import { render } from "./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue?vue&type=template&id=631fe44e"
import script from "./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__